import {
  sanitize,
  getDisallowedCharactersRegex,
} from 'common/src/vtj/sanitization/sanitizers'

type SanitizeOptions = Partial<{
  lineBreaksToSpace: boolean
  latin1SupplementLetters: boolean
  latin1CommonSpecialSansXss: boolean
  basicLatin: boolean
  space: boolean
  allowMultispace: boolean
  trim: boolean
  latin1Supplement: boolean
  basicPunctuation: boolean
  lineBreak: boolean
  letters: boolean
  numbers: boolean
  decimals: boolean
  plusMinus: boolean
  transformToLowerCase: boolean
  legalCode: boolean
  micro: boolean
  safeUrlCharacters: boolean
}>

const MAIL_DELIVERY_SANITIZATION_RULES: SanitizeOptions = {
  letters: true,
  numbers: true,
  space: true,
  latin1SupplementLetters: true,
  latin1CommonSpecialSansXss: true,
  allowMultispace: false,
  basicLatin: false,
  trim: true,
  micro: false,
}

export const REGEX_MAIL_DELIVERY_NOT_ALLOWED_CHARACTERS = new RegExp(
  '[^\u0027' +
    getDisallowedCharactersRegex(MAIL_DELIVERY_SANITIZATION_RULES)
      .toString()
      .slice(3, -2),
  'g'
)

export const sanitizeMailDeliveryInput = (input: string): string =>
  sanitize(input, {
    ...MAIL_DELIVERY_SANITIZATION_RULES,
    basicPunctuation: true,
  }).replaceAll(REGEX_MAIL_DELIVERY_NOT_ALLOWED_CHARACTERS, '')

const TEXT_INPUT_WHITESPACE_NORMALIZATION_RULES: SanitizeOptions = {
  lineBreaksToSpace: true,
  latin1SupplementLetters: true,
  latin1CommonSpecialSansXss: true,
  basicLatin: true,
  space: true,
  allowMultispace: false,
  trim: true,
  latin1Supplement: true,
  basicPunctuation: true,
  lineBreak: false,
  letters: true,
  numbers: true,
  decimals: true,
  plusMinus: true,
  transformToLowerCase: false,
  legalCode: true,
  micro: true,
  safeUrlCharacters: true,
}

export const normalizeTextInputWhitespace = (input: unknown): string =>
  typeof input === 'string'
    ? sanitize(input, TEXT_INPUT_WHITESPACE_NORMALIZATION_RULES)
    : ''

export const REGEX_LAST_NAME_NOT_ALLOWED_CHARACTERS =
  REGEX_MAIL_DELIVERY_NOT_ALLOWED_CHARACTERS
